module.exports = __webpack_public_path__ + "static/media/purchaseAlone.7eb9fb58.png";